import { endpoints, request } from '!core/api';

export const accountBalanceServices = {
  accountBalance: (securityAccount, currency) =>
    request.get(
      endpoints.backoffice(
        `WsbGetAccountBalance?account=${securityAccount}${
          currency ? `&currency=${currency}` : ''
        }`,
      ),
    ),
};
